__turbopack_context__.v({
  "ball": "LotteryEntry-module__6Gu-4W__ball",
  "ballInner": "LotteryEntry-module__6Gu-4W__ballInner",
  "ballInner2": "LotteryEntry-module__6Gu-4W__ballInner2",
  "bonusBall": "LotteryEntry-module__6Gu-4W__bonusBall",
  "container": "LotteryEntry-module__6Gu-4W__container",
  "disabled": "LotteryEntry-module__6Gu-4W__disabled",
  "firstEntryDisabled": "LotteryEntry-module__6Gu-4W__firstEntryDisabled",
});
